export enum PanelType {
  SampleGallery = "sample-gallery",
  Survey = "survey",
  RespondToCardActions = "respond-to-card-actions",
  AccountHelp = "account-help",
}
